import { Fetcher } from 'packages/http-client/fetcher';
import { createContext } from 'react';

export const FetcherContext = createContext<Fetcher>(null as any);
